import React from 'react';

import useBreadcrumbs from 'use-react-router-breadcrumbs';
import './Breadcrumbs.scss';
import './Breadcrumbs-media.scss';
import { Props } from './interfaces';
import { ListUriLive } from '../../services/content/Constants';
import { SchemaJsonBreadcrumbList } from './Functions';
import {Link} from "../Link/Link";

const Breadcrumbs = ({ title = '' }: Props) => {
  const breadcrumbs = useBreadcrumbs([
    { path: '/', breadcrumb: 'Главная' },
    { path: '/blog/', breadcrumb: 'Блог' },
    { path: '/blog/:id', breadcrumb: title },
  ]);

  return (
    <div className="breadcrumbs">
      <SchemaJsonBreadcrumbList title={title} section="blog" />

      {breadcrumbs.map(({ match, breadcrumb }, i) => (
        <>
          <span className="breadcrumbs__item" key={match.pathname}>
            <Link to={match.pathname + (i !== 0 ? '/' : '')} className="breadcrumbs__link">
              {breadcrumb}
            </Link>
          </span>
          {i < breadcrumbs.length - 1 && breadcrumbs.length > 1 && <span className={'breadcrumbs__delimiter'}>•</span> }
        </>
      ))}
    </div>
  );
};

export default Breadcrumbs;
